import React, { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, CircularProgress, Snackbar, Alert } from '@mui/material';

import FavoriteList from './FavoriteList';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import useAuth from 'hooks/useAuth';
import { getClipItems, addClipItem, deleteClipItem } from 'utils/function/wp-api';

// ==============================|| USER LIST STYLE 1 ||============================== //

const Favorite = () => {
  const theme = useTheme();
  const [clipItemData, setClipItemData] = useState([]);
  const [clipItem, setClipItem] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const { userProfile, tokens } = useAuth();

  // スナックバー用の状態
  const [snackbarOpen, setSnackbarOpen] = useState({ open: false, message: '', severity: 'success' });

  const headers1 = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${process.env.REACT_APP_WP_JWT_TOKEN}`
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen((prev) => ({ ...prev, open: false }));
  };

  const handleSaveClip = async () => {
    // console.log('start handleSaveClip');
    const queryParams = new URLSearchParams(window.location.search);
    const encodedUrl = queryParams.get('u');
    let postId = null;

    if (encodedUrl) {
      const decodedUrl = decodeURIComponent(encodedUrl);
      const match = decodedUrl.match(/\/(\d+)$/);
      if (match) {
        postId = match[1];
      }
    }

    if (postId === null) {
      return;
    }

    const data = {
      provider_userid: userProfile.provider_userid,
      postId
    };

    try {
      const res = await addClipItem(headers1, data);
      // console.log('res', res);

      // クエリパラメータを削除
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);

      // スナックバー表示: 成功
      setSnackbarOpen({ open: true, message: 'クリップ記事が追加されました！', severity: 'success' });
      setLoading(false);
    } catch (error) {
      // console.log('error', error);
      // スナックバー表示: 失敗
      setSnackbarOpen({ open: true, message: 'クリップ記事の追加に失敗しました', severity: 'error' });
    }
    // console.log('end handleSaveClip');
  };

  const handleGetClipItems = async () => {
    const data = {
      provider_userid: userProfile.provider_userid,
      per_page: rowsPerPage,
      page: page + 1
    };
    try {
      const res = await getClipItems(headers1, data);
      // console.log('res', res);
      setClipItemData([...res.data.data]);
      setClipItem(res.data);
    } catch (error) {
      // console.log('error', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClip = async (e, row) => {
    e.stopPropagation();
    // console.log('handleDeleteClip', row);
    const data = {
      provider_userid: userProfile.provider_userid,
      postId: row.postId
    };
    try {
      const res = await deleteClipItem(headers1, data);
      // console.log('res', res);
      setSnackbarOpen({ open: true, message: 'クリップ記事が削除されました', severity: 'success' });
      await handleGetClipItems();
    } catch (error) {
      // console.log('error', error);
      setSnackbarOpen({ open: true, message: 'クリップ記事の削除に失敗しました', severity: 'error' });
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await handleSaveClip(); // handleSaveClip の完了を待つ
        await handleGetClipItems(); // handleGetClipItems を続けて呼び出す
      } catch (error) {
        console.error('Error in useEffect:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [page, rowsPerPage]);

  return (
    <MainCard
      title={
        <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
          <Grid item>
            <Typography variant="h3">クリップ記事</Typography>
          </Grid>
        </Grid>
      }
      content={false}
    >
      {/* スナックバー */}
      <Snackbar
        open={snackbarOpen.open}
        autoHideDuration={3000} // 3秒で自動的に閉じる
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // 表示位置
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarOpen.severity} sx={{ width: '100%', backgroundColor: '#e9eaf4' }}>
          {snackbarOpen.message}
        </Alert>
      </Snackbar>

      {isLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <CircularProgress />
        </div>
      ) : (
        <FavoriteList
          isLoading={isLoading}
          clipData={clipItemData}
          clipItem={clipItem}
          getCouponsList={handleGetClipItems}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          page={page}
          setPage={setPage}
          handleDeleteClip={handleDeleteClip}
        />
      )}
    </MainCard>
  );
};

export default Favorite;
